import React from "react";
import { useNavigate } from "react-router-dom";

const BlogCard = ({ blog }) => {
  const navigate = useNavigate();
  return (
    <div className="max-sm:max-w-[100%] bg-white max-sm:mt-[0px] shadow-lg rounded-[25px] overflow-hidden h-fit max-w-[420px]">
      <div className="relative z-[1]">
        <img
          src={blog.image}
          alt="Blog Image"
          className="w-full object-cover h-auto"
        />
        <div className="absolute bottom-0 z-[3] tex-grey left-[0]">
          <img src="../../assets/images/home/blog-date-design.png" alt="" />
          <p className="text-[#9B9B9B] text-center mt-[-32px] mr-[10%] small font-medium leading-[30px] font-manrope">
            {blog.date} / {blog.author}
          </p>
        </div>
      </div>

      <div className="pt-[50px] pb-[45px] px-[38px]">
        <h5
          className="leading-[35px] cursor-pointer tracking-[-0.75] font-sora"
          onClick={() => {
            navigate("/blog-detail");
          }}
        >
          {blog.title}
        </h5>
        <span className="mt-[57px] inline-block font-medium small font-manrope text-[#9B9B9B]">
          {blog.categories}
        </span>
      </div>
    </div>
  );
};

export default BlogCard;
